import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';

import MypageReturn from '../molecules/MypageReturn';
import RowCenterButton from '../molecules/RowCenterButton';
import DefaultButton from '../molecules/DefaultButton';
import Paragraph from '../molecules/Paragraph';

interface Props {
  opened_mypage: boolean;
  is_staff: boolean;
  reception_cd: string;
  reception_id: number;
  status_code: number;
  moveNextStep: () => void;
  requestModule: () => void | boolean;
  requestModuleAutodisplay: () => void | boolean;
}

// KWANKGM03010_事前審査申込入力詳細フッタボタン
const FooterPreExaminationApplicationInputDetail: React.FC<Props> = ({
  opened_mypage,
  is_staff,
  reception_cd,
  reception_id,
  status_code,
  moveNextStep,
  requestModule,
  requestModuleAutodisplay,
}) => {
  const history = useHistory();

  /**
   * ナビゲーションと画面を確認画面に遷移
   */
  const handleClickNext = async () => {
    const autodispay_result = await requestModuleAutodisplay();
    const valid_result = await requestModule();

    // バリデーションエラーがあるか判定
    if (valid_result) {
      // エラーが無ければ確認画面へ遷移
      moveNextStep();
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/confirm`);
    }
  };

  return (
    <>
      <RowCenterButton>
        <DefaultButton label="事前審査申込をする" strong={false} handleClick={handleClickNext} />
      </RowCenterButton>
      {opened_mypage ? (
        <MypageReturn is_staff={is_staff} />
      ) : (
        <Paragraph
          label="本ページを閉じる場合はウィンドウまたはタブを閉じて下さい。"
          is_paragraph={false}
        />
      )}
    </>
  );
};

export default memo(FooterPreExaminationApplicationInputDetail);
